import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink, Redirect } from 'react-router-dom'
import { Row, Col, Button, Icon, Tabs, Tooltip } from 'antd'
import moment from 'moment'
import _ from 'lodash'

import * as actions from './TemplateEditPageActions'
import * as totalCalculator from '../utils/totalCalculator'
import TemplateBackgroundInformationForm from '../Commons/TemplateBackgroundInformationForm/TemplateBackgroundInformationForm'
import TemplateContentForm from '../Commons/TemplateContentForm/TemplateContentForm'
import TermsAndConditionsForm from '../Commons/TermsAndConditionsForm/TermsAndConditionsForm'
import AppendixList from '../Commons/AppendixList/AppendixList'
import './TemplateEditPage.scss'

const { getGrandTotal } = totalCalculator
const TabPane = Tabs.TabPane

export class TemplateEditPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            createdAt: '',
            backgroundInformation: {
                name: 'New Template',
            },
            sections: [],
            discounts: [],
            grandTotal: 0,
            termsAndConditions: {
                payments: [],
                sections: []
            },
            appendix: [],
            smartSaerchFilter: {},
            isContentChanged: false
        }

        this.handleTemplateSave = this.handleTemplateSave.bind(this)
        this.handleTemplateDelete = this.handleTemplateDelete.bind(this)
        this.updatePaymentAmount = this.updatePaymentAmount.bind(this)
    }

    updatePaymentAmount() {
        const { grandTotal, termsAndConditions } = this.state
        let newTermsAndConditions = _.cloneDeep(termsAndConditions)

        newTermsAndConditions.payments = _.map(newTermsAndConditions.payments, (payment) => ({ ...payment, amount: payment.percentage ? +(grandTotal * payment.percentage / 100).toFixed(1) : payment.amount }))

        this.setState({ termsAndConditions: newTermsAndConditions })
    }

    handleTemplateSave() {
        const { match, saveTemplate, updateTemplate, token } = this.props
        const { sections, discounts, grandTotal, backgroundInformation, termsAndConditions, appendix, isContentChanged } = this.state
        const { templateId } = match.params

        if (isContentChanged) {
            if (templateId)
                updateTemplate(token, templateId, backgroundInformation, { sections, discounts, grandTotal }, termsAndConditions, appendix)
            else
                saveTemplate(token, backgroundInformation, { sections, discounts, grandTotal }, termsAndConditions, appendix)

            this.setState({ isContentChanged: false })
        }
    }

    handleTemplateDelete() {
        const { match, deleteTemplate, token } = this.props
        const { templateId } = match.params

        deleteTemplate(token, templateId)
    }

    handleSmartSearchFilterChange(field, value) {
        let newSmartSaerchFilter = _.cloneDeep(this.state.smartSaerchFilter)
        newSmartSaerchFilter[field] = value
        this.setState({ smartSaerchFilter: newSmartSaerchFilter })
    }

    // Template Background Information
    handleBackgroundInformationInputChange(field, value) {
        let newBackgroundInformation = _.cloneDeep(this.state.backgroundInformation)
        if (typeof(value) !== 'object') {
            newBackgroundInformation[field] = value
        } else {
            newBackgroundInformation[field] = value.target.value
        }

        this.setState({ backgroundInformation: newBackgroundInformation, isContentChanged: true })
    }

    // Template Content - Section
    handleSectionAdd() {
        const { discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        newSections.push({
            name: '',
            items: [],
            remarks: []
        })

        this.setState({ grandTotal: getGrandTotal('template', newSections, {}, discounts), sections: newSections, isContentChanged: true })
    }

    handleSectionRemove(sectionIdx) {
        const { discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        newSections.splice(sectionIdx, 1)

        this.setState({ grandTotal: getGrandTotal('template', newSections, {}, discounts), sections: newSections, isContentChanged: true })
    }

    handleSectionChange(sectionIdx, field, e) {
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx][field] = e.target.value
        this.setState({ sections: newSections, isContentChanged: true })
    }

    handleSectionToggle(sectionIdx) {
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].toggled = !newSections[sectionIdx].toggled
        this.setState({ sections: newSections })
    }

    handleSectionRemarkAdd(sectionIdx) {
        let newSections = _.cloneDeep(this.state.sections)
        if (_.isEmpty(newSections[sectionIdx].remarks))
            newSections[sectionIdx].remarks = []
        newSections[sectionIdx].remarks.push('New Remark')

        this.setState({ sections: newSections, isContentChanged: true })
    }

    handleSectionRemarkInsert(sectionIdx, remarkIdx) {
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].remarks.splice(remarkIdx, 0, '')

        this.setState({ sections: newSections, isContentChanged: true })
    }

    handleSectionRemarkRemove(sectionIdx, remarkIdx) {
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].remarks.splice(remarkIdx, 1)

        this.setState({ sections: newSections, isContentChanged: true })
    }

    handleSectionRemarkChange(sectionIdx, remarkIdx, e) {
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].remarks[remarkIdx] = e.target.value

        this.setState({ sections: newSections, isContentChanged: true })
    }

    // Template Content - Section Item
    handleSectionItemFocus(sectionIdx, itemIdx, e) {
        const { fetchItemSmartSuggestionList, token, itemSmartSuggestionList } = this.props
        const { sections, smartSaerchFilter } = this.state
        const itemName = sections[sectionIdx].items[itemIdx].name
        if (itemName) {
            if (itemSmartSuggestionList.keyword !== itemName)
                fetchItemSmartSuggestionList(token, itemName, smartSaerchFilter)
        }
    }

    handleSectionItemSmartSelect(sectionIdx, itemIdx, selectedItem) {
        const { discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        const { quantity, basic_charge_quantity, basic_charge, unit_rate, unit } = selectedItem

        newSections[sectionIdx].items[itemIdx].quantity = quantity
        newSections[sectionIdx].items[itemIdx].basic_charge_quantity = basic_charge_quantity
        newSections[sectionIdx].items[itemIdx].basic_charge = basic_charge
        newSections[sectionIdx].items[itemIdx].unit_rate = unit_rate
        newSections[sectionIdx].items[itemIdx].unit = unit

        this.setState({ grandTotal: getGrandTotal('template', newSections, {}, discounts), sections: newSections, isContentChanged: true })
    }

    handleSectionItemAdd(sectionIdx) {
        const { discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].items.push({
            name: '',
            quantity: 0,
            unit_rate: 0,
            unit: ''
        })

        this.setState({ grandTotal: getGrandTotal('template', newSections, {}, discounts), sections: newSections, isContentChanged: true })
    }

    handleSectionItemInsert(sectionIdx, itemIdx) {
        const { discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].items.splice(itemIdx, 0, {
            name: '',
            quantity: 0,
            unit_rate: 0,
            unit: ''
        })

        this.setState({ grandTotal: getGrandTotal('template', newSections, {}, discounts), sections: newSections, isContentChanged: true })
    }

    handleSectionItemRemove(sectionIdx, itemIdx) {
        const { discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].items.splice(itemIdx, 1)

        this.setState({ grandTotal: getGrandTotal('template', newSections, {}, discounts), sections: newSections, isContentChanged: true })
    }

    handleSectionItemChange(sectionIdx, itemIdx, field, e) {
        const { discounts } = this.state
        let newState = { isContentChanged: true }
        let newSections = _.cloneDeep(this.state.sections)

        if (typeof(e) === 'object') {
            newSections[sectionIdx].items[itemIdx][field] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
        } else {
            newSections[sectionIdx].items[itemIdx][field] = e
        }
        newState.grandTotal = getGrandTotal('template', newSections, {}, discounts)
        newState.sections = newSections

        this.setState(newState)
    }

    // Template Content - Discounts
    handleDiscountAdd() {
        const { sections } = this.state
        let newDiscounts = _.cloneDeep(this.state.discounts)
        newDiscounts.push({
            name: '',
            amount: 0
        })

        this.setState({ grandTotal: getGrandTotal('template', sections, {}, newDiscounts), discounts: newDiscounts, isContentChanged: true })
    }

    handleDiscountRemove(discountIdx) {
        const { sections } = this.state
        let newDiscounts = _.cloneDeep(this.state.discounts)
        newDiscounts.splice(discountIdx, 1)

        this.setState({ grandTotal: getGrandTotal('template', sections, {}, newDiscounts), discounts: newDiscounts, isContentChanged: true })
    }

    handleDiscountChange(discountIdx, field, e) {
        const { sections } = this.state
        let newDiscounts = _.cloneDeep(this.state.discounts)
        if (typeof(e) === 'object') {
            newDiscounts[discountIdx][field] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
        } else {
            newDiscounts[discountIdx][field] = e
        }

        this.setState({ grandTotal: getGrandTotal('template', sections, {}, newDiscounts), discounts: newDiscounts, isContentChanged: true })
    }

    // Template T&C - Payments
    handleTNCPaymentAdd() {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)

        newTermsAndConditions.payments.push({
            name: '',
            amount: 0,
            description: '',
            paid: false,
            invoice_sent: false,
            receive_sent: false
        })

        this.setState({ termsAndConditions: newTermsAndConditions, isContentChanged: true })
    }

    handleTNCPaymentRemove(paymentIdx) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.payments.splice(paymentIdx, 1)
        this.setState({ termsAndConditions: newTermsAndConditions, isContentChanged: true })
    }
    handleTNCPaymentDateChange(paymentIdx, field, date, dateString) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.payments[paymentIdx][field] = date ? moment(dateString).startOf('day') : undefined
        this.setState({ termsAndConditions: newTermsAndConditions, isContentChanged: true })
    }

    handleTNCPaymentChange(paymentIdx, field, e) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.payments[paymentIdx][field] = e.target.value
        this.setState({ termsAndConditions: newTermsAndConditions, isContentChanged: true })
    }

    handleTNCPaymentNumberChange(paymentIdx, field, value) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.payments[paymentIdx][field] = value
        if (field === 'percentage') {
            newTermsAndConditions.payments[paymentIdx]['amount'] = +(this.state.grandTotal * value / 100).toFixed(1) || 0
        }

        this.setState({ termsAndConditions: newTermsAndConditions, isContentChanged: true })
    }

    // Template T&C - Sections
    handleTNCSectionAdd() {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.sections.push({
            title: '',
            description: ''
        })
        this.setState({ termsAndConditions: newTermsAndConditions, isContentChanged: true })
    }

    handleTNCSectionRemove(sectionIdx) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.sections.splice(sectionIdx, 1)
        this.setState({ termsAndConditions: newTermsAndConditions, isContentChanged: true })
    }

    handleTNCSectionChange(sectionIdx, field, e) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.sections[sectionIdx][field] = e.target.value
        this.setState({ termsAndConditions: newTermsAndConditions, isContentChanged: true })
    }

    // Apendix Section
    handleAppendixItemAdd() {
        let newAppendix = _.cloneDeep(this.state.appendix)
        newAppendix.push({ imageUrl: '', description: '' })
        this.setState({ appendix: newAppendix, isContentChanged: true })
    }

    handleAppendixItemRemove(itemIdx) {
        let newAppendix = _.cloneDeep(this.state.appendix)
        newAppendix.splice(itemIdx, 1)
        this.setState({ appendix: newAppendix, isContentChanged: true })
    }

    handleAppendixItemChange(itemIdx, field, e) {
        let newAppendix = _.cloneDeep(this.state.appendix)
        if (typeof(e) === 'object') {
            newAppendix[itemIdx][field] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
        } else {
            newAppendix[itemIdx][field] = e
        }
        this.setState({ appendix: newAppendix, isContentChanged: true })
    }

    componentWillMount() {
        const { match, fetchTemplate, fetchItemList, fetchUnitList, fetchLocationList, fetchEstateList, token } = this.props
        const { templateId } = match.params

        if (templateId)
            fetchTemplate(token, templateId)

        // Fetch list of item for item name suggestion
        fetchItemList(token)

        fetchUnitList(token)
        // Fetch list of location and estate for filter
        fetchLocationList(token)
        fetchEstateList(token)

    }

    componentDidUpdate(prevProps, prevState) {
        const { token, template, itemSmartSuggestionList } = this.props
        const { smartSaerchFilter, grandTotal } = this.state

        if (!_.isEqual(prevProps.template, template)) {
            const {
                name,
                category,
                type,
                size,
                estate_name,
                site_location,
                site_address,
                flat,
                floor,
                client_name,
                company_name,
                client_email,
                client_number,
                sections,
                discounts,
                grand_total,
                created_at,
                terms_and_conditions,
                appendix
            } = template

            this.setState({
                backgroundInformation: {
                    name,
                    category,
                    type,
                    size,
                    estate_name,
                    site_location,
                    site_address,
                    flat,
                    floor,
                    client_name,
                    company_name,
                    client_email,
                    client_number,
                },
                sections,
                discounts,
                grandTotal: grand_total,
                createdAt: created_at,
                termsAndConditions: terms_and_conditions,
                appendix
            })
        }

        if (!_.isEqual(prevState.smartSaerchFilter, smartSaerchFilter) && !_.isEmpty(itemSmartSuggestionList)) {
            const { fetchItemSmartSuggestionList } = this.props
            fetchItemSmartSuggestionList(token, itemSmartSuggestionList.keyword, smartSaerchFilter)
        }

        if (prevState.grandTotal !== grandTotal) {
            this.updatePaymentAmount()
        }
    }

    renderTemplateBackgrounInformationSection() {
        const { backgroundInformation } = this.state

        return (
            <TabPane tab="Background" key="1">
                <div className="tab-content-container">
                    <h4>Template Information</h4>
                    <TemplateBackgroundInformationForm
                        backgroundInformation={backgroundInformation}
                        onInputChange={(field, value) => this.handleBackgroundInformationInputChange(field, value)}
                    />
                </div>
            </TabPane>
        )
    }

    renderTemplateContentSection() {
        const { token, removeItemName, itemList, unitList, locationList, estateList, itemSmartSuggestionList } = this.props
        const { sections, discounts, grandTotal, smartSaerchFilter } = this.state

        return (
            <TabPane tab="Content" key="2">
                <div className="tab-content-container">
                    <TemplateContentForm
                        token={token}
                        sections={sections}
                        discounts={discounts}
                        grandTotal={grandTotal}
                        itemNameSuggestionList={itemList}
                        removeItemName={removeItemName}
                        unitSuggestionList={unitList}
                        smartSaerchFilter={smartSaerchFilter}
                        locationList={locationList}
                        estateList={estateList}
                        onSmartSearchFilterChange={(field, value) => this.handleSmartSearchFilterChange(field, value)}
                        itemSmartSuggestionList={itemSmartSuggestionList}
                        onSuggestionItemClick={(sectionIdx, itemIdx, selectedItem) => this.handleSectionItemSmartSelect(sectionIdx, itemIdx, selectedItem)}
                        onSectionAdd={() => this.handleSectionAdd()}
                        onSectionRemove={(sectionIdx) => this.handleSectionRemove(sectionIdx)}
                        onSectionChange={(sectionIdx, field, e) => this.handleSectionChange(sectionIdx, field, e)}
                        onSectionToggle={(sectionIdx) => this.handleSectionToggle(sectionIdx)}
                        onSectionRemarkAdd={(sectionIdx) => this.handleSectionRemarkAdd(sectionIdx)}
                        onSectionRemarkInsert={(sectionIdx, remarkIdx) => this.handleSectionRemarkInsert(sectionIdx, remarkIdx)}
                        onSectionRemarkRemove={(sectionIdx, remarkIdx) => this.handleSectionRemarkRemove(sectionIdx, remarkIdx)}
                        onSectionRemarkChange={(sectionIdx, remarkIdx, e) => this.handleSectionRemarkChange(sectionIdx, remarkIdx, e)}
                        onItemAdd={(sectionIdx) => this.handleSectionItemAdd(sectionIdx)}
                        onItemInsert={(sectionIdx, itemIdx) => this.handleSectionItemInsert(sectionIdx, itemIdx)}
                        onItemRemove={(sectionIdx, itemIdx) => this.handleSectionItemRemove(sectionIdx, itemIdx)}
                        onItemChange={(sectionIdx, itemIdx, field, e) => this.handleSectionItemChange(sectionIdx, itemIdx, field, e)}
                        onItemFocus={(sectionIdx, itemIdx, e) => this.handleSectionItemFocus(sectionIdx, itemIdx, e)}
                        onDiscountAdd={() => this.handleDiscountAdd()}
                        onDiscountRemove={(discountIdx) => this.handleDiscountRemove(discountIdx)}
                        onDiscountChange={(discountIdx, field, e) => this.handleDiscountChange(discountIdx, field, e)}
                    />
                </div>
            </TabPane>
        )
    }

    renderTermsAndConditionsSection() {
        const { termsAndConditions } = this.state

        return (
            <TabPane tab="T&C" key="3">
                <div className="tab-content-container">
                    <h4>Terms and Conditions</h4>
                    <TermsAndConditionsForm
                        type="template"
                        termsAndConditions={termsAndConditions}
                        onPaymentAdd={() => this.handleTNCPaymentAdd()}
                        onPaymentRemove={(paymentIdx) => this.handleTNCPaymentRemove(paymentIdx)}
                        onPaymentChange={(paymentIdx, field, e) => this.handleTNCPaymentChange(paymentIdx, field, e)}
                        onPaymentNumberChange={(paymentIdx, field, value) => this.handleTNCPaymentNumberChange(paymentIdx, field, value)}
                        onPaymentDateChange={(paymentIdx, field, date, dateString) => this.handleTNCPaymentDateChange(paymentIdx, field, date, dateString)}
                        onSectionAdd={() => this.handleTNCSectionAdd()}
                        onSectionRemove={(sectionIdx) => this.handleTNCSectionRemove(sectionIdx)}
                        onSectionChange={(sectionIdx, field, e) => this.handleTNCSectionChange(sectionIdx, field, e)}
                    />
                </div>
            </TabPane>
        )
    }

    renderTemplateAppendixSection() {
        const { sections, appendix } = this.state

        return (
            <TabPane tab="Appendix" key="4">
                <div className="tab-content-container">
                    <AppendixList
                        sectionsList={sections}
                        appendix={appendix}
                        onAppendixItemAdd={() => this.handleAppendixItemAdd()}
                        onAppendixItemRemove={(itemIdx) => this.handleAppendixItemRemove(itemIdx)}
                        onAppendixItemChange={(itemIdx, field, e) => this.handleAppendixItemChange(itemIdx, field, e)}
                        onItemChange={(sectionIdx, itemIdx, field, e) => this.handleSectionItemChange(sectionIdx, itemIdx, field, e)}
                    />
                </div>
            </TabPane>
        )
    }

    render() {
        const { match, redirectRequest } = this.props
        const { backgroundInformation, createdAt, isContentChanged } = this.state
        const isNewTemplate = match.path === '/workdesk/template/new'

        if (redirectRequest !== '')
            return <Redirect to={redirectRequest} />
        else
            return (
                <div className="TemplateEditPage">
                    <div className="template-panel">
                        <Row gutter={8}>
                            <Col span={19} offset={1}>
                                <div className="main-body">
                                    <h3 className="template-name">{backgroundInformation.name}</h3>
                                    <p className="template-info">{ createdAt ? `Created at ${moment(createdAt).format('DD-MM-YYYY')}` : ''}</p>
                                    <Tabs type="card">
                                        {this.renderTemplateBackgrounInformationSection()}
                                        {this.renderTemplateContentSection()}
                                        {this.renderTermsAndConditionsSection()}
                                        {this.renderTemplateAppendixSection()}
                                    </Tabs>
                                </div>
                            </Col>
                            <Col span={3}>
                                <div className="btn-container">
                                    { !isNewTemplate && <Button className="delete-btn" type="primary" size="large" onClick={this.handleTemplateDelete}>Delete</Button> }
                                    <Button className={isContentChanged ? 'changed': ''} type="primary" size="large" onClick={this.handleTemplateSave}>Save</Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <NavLink to="/workdesk">
                        <div className="home-btn">
                            <Tooltip placement="top" title="Home">
                                    <Icon type="home" />
                            </Tooltip>
                        </div>
                    </NavLink>
                </div>
            )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        redirectRequest: state.templateEditPage.redirectRequest,
        template: state.templateEditPage.template,
        itemList: state.templateEditPage.itemList,
        unitList: state.templateEditPage.unitList,
        locationList: state.app.locationList,
        estateList: state.app.estateList,
        itemSmartSuggestionList: state.templateEditPage.itemSmartSuggestionList
    }
}

export default connect(mapStateToProps, actions)(TemplateEditPage)


// WEBPACK FOOTER //
// ./src/TemplateEditPage/TemplateEditPage.js